import { render, staticRenderFns } from "./yicheng.vue?vue&type=template&id=b3b1a514&scoped=true&"
import script from "./yicheng.vue?vue&type=script&lang=js&"
export * from "./yicheng.vue?vue&type=script&lang=js&"
import style0 from "./yicheng.vue?vue&type=style&index=0&id=b3b1a514&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b1a514",
  null
  
)

export default component.exports